// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader@6.11.0_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.nkl-skeleton {
  display: table;
  width: 100%;
}
.nkl-skeleton-header {
  display: table-cell;
  padding-right: 16px;
  vertical-align: top;
}
.nkl-skeleton-header .nkl-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.nkl-skeleton-header .nkl-skeleton-avatar.nkl-skeleton-avatar-circle {
  border-radius: 50%;
}
.nkl-skeleton-header .nkl-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.nkl-skeleton-header .nkl-skeleton-avatar-lg.nkl-skeleton-avatar-circle {
  border-radius: 50%;
}
.nkl-skeleton-header .nkl-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.nkl-skeleton-header .nkl-skeleton-avatar-sm.nkl-skeleton-avatar-circle {
  border-radius: 50%;
}
.nkl-skeleton-content {
  display: table-cell;
  width: 100%;
  vertical-align: top;
}
.nkl-skeleton-content .nkl-skeleton-title {
  width: 100%;
  height: 16px;
  background: rgba(190, 190, 190, 0.2);
  border-radius: 2px;
}
.nkl-skeleton-content .nkl-skeleton-title + .nkl-skeleton-paragraph {
  margin-top: 24px;
}
.nkl-skeleton-content .nkl-skeleton-paragraph {
  padding: 0;
}
.nkl-skeleton-content .nkl-skeleton-paragraph > li {
  width: 100%;
  height: 16px;
  list-style: none;
  background: rgba(190, 190, 190, 0.2);
  border-radius: 2px;
}
.nkl-skeleton-content .nkl-skeleton-paragraph > li:last-child:not(:first-child):not(:nth-child(2)) {
  width: 61%;
}
.nkl-skeleton-content .nkl-skeleton-paragraph > li + li {
  margin-top: 16px;
}
.nkl-skeleton-with-avatar .nkl-skeleton-content .nkl-skeleton-title {
  margin-top: 12px;
}
.nkl-skeleton-with-avatar .nkl-skeleton-content .nkl-skeleton-title + .nkl-skeleton-paragraph {
  margin-top: 28px;
}
.nkl-skeleton-round .nkl-skeleton-content .nkl-skeleton-title,
.nkl-skeleton-round .nkl-skeleton-content .nkl-skeleton-paragraph > li {
  border-radius: 100px;
}
.nkl-skeleton-active .nkl-skeleton-title,
.nkl-skeleton-active .nkl-skeleton-paragraph > li,
.nkl-skeleton-active .nkl-skeleton-avatar,
.nkl-skeleton-active .nkl-skeleton-button,
.nkl-skeleton-active .nkl-skeleton-input,
.nkl-skeleton-active .nkl-skeleton-image {
  position: relative;
  /* stylelint-disable-next-line property-no-vendor-prefix,value-no-vendor-prefix */
  z-index: 0;
  overflow: hidden;
  background: transparent;
}
.nkl-skeleton-active .nkl-skeleton-title::after,
.nkl-skeleton-active .nkl-skeleton-paragraph > li::after,
.nkl-skeleton-active .nkl-skeleton-avatar::after,
.nkl-skeleton-active .nkl-skeleton-button::after,
.nkl-skeleton-active .nkl-skeleton-input::after,
.nkl-skeleton-active .nkl-skeleton-image::after {
  position: absolute;
  top: 0;
  right: -150%;
  bottom: 0;
  left: -150%;
  background: linear-gradient(90deg, rgba(190, 190, 190, 0.2) 25%, rgba(129, 129, 129, 0.24) 37%, rgba(190, 190, 190, 0.2) 63%);
  animation: nkl-skeleton-loading 1.4s ease infinite;
  content: '';
}
.nkl-skeleton.nkl-skeleton-block {
  width: 100%;
}
.nkl-skeleton.nkl-skeleton-block .nkl-skeleton-button {
  width: 100%;
}
.nkl-skeleton.nkl-skeleton-block .nkl-skeleton-input {
  width: 100%;
}
.nkl-skeleton-element {
  display: inline-block;
  width: auto;
}
.nkl-skeleton-element .nkl-skeleton-button {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  border-radius: 2px;
  width: 64px;
  min-width: 64px;
  height: 32px;
  line-height: 32px;
}
.nkl-skeleton-element .nkl-skeleton-button.nkl-skeleton-button-square {
  width: 32px;
  min-width: 32px;
}
.nkl-skeleton-element .nkl-skeleton-button.nkl-skeleton-button-circle {
  width: 32px;
  min-width: 32px;
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-button.nkl-skeleton-button-round {
  border-radius: 32px;
}
.nkl-skeleton-element .nkl-skeleton-button-lg {
  width: 80px;
  min-width: 80px;
  height: 40px;
  line-height: 40px;
}
.nkl-skeleton-element .nkl-skeleton-button-lg.nkl-skeleton-button-square {
  width: 40px;
  min-width: 40px;
}
.nkl-skeleton-element .nkl-skeleton-button-lg.nkl-skeleton-button-circle {
  width: 40px;
  min-width: 40px;
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-button-lg.nkl-skeleton-button-round {
  border-radius: 40px;
}
.nkl-skeleton-element .nkl-skeleton-button-sm {
  width: 48px;
  min-width: 48px;
  height: 24px;
  line-height: 24px;
}
.nkl-skeleton-element .nkl-skeleton-button-sm.nkl-skeleton-button-square {
  width: 24px;
  min-width: 24px;
}
.nkl-skeleton-element .nkl-skeleton-button-sm.nkl-skeleton-button-circle {
  width: 24px;
  min-width: 24px;
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-button-sm.nkl-skeleton-button-round {
  border-radius: 24px;
}
.nkl-skeleton-element .nkl-skeleton-avatar {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 32px;
  height: 32px;
  line-height: 32px;
}
.nkl-skeleton-element .nkl-skeleton-avatar.nkl-skeleton-avatar-circle {
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-avatar-lg {
  width: 40px;
  height: 40px;
  line-height: 40px;
}
.nkl-skeleton-element .nkl-skeleton-avatar-lg.nkl-skeleton-avatar-circle {
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-avatar-sm {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
.nkl-skeleton-element .nkl-skeleton-avatar-sm.nkl-skeleton-avatar-circle {
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-input {
  display: inline-block;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 160px;
  min-width: 160px;
  height: 32px;
  line-height: 32px;
}
.nkl-skeleton-element .nkl-skeleton-input-lg {
  width: 200px;
  min-width: 200px;
  height: 40px;
  line-height: 40px;
}
.nkl-skeleton-element .nkl-skeleton-input-sm {
  width: 120px;
  min-width: 120px;
  height: 24px;
  line-height: 24px;
}
.nkl-skeleton-element .nkl-skeleton-image {
  display: flex;
  align-items: center;
  justify-content: center;
  vertical-align: top;
  background: rgba(190, 190, 190, 0.2);
  width: 96px;
  height: 96px;
  line-height: 96px;
}
.nkl-skeleton-element .nkl-skeleton-image.nkl-skeleton-image-circle {
  border-radius: 50%;
}
.nkl-skeleton-element .nkl-skeleton-image-path {
  fill: #bfbfbf;
}
.nkl-skeleton-element .nkl-skeleton-image-svg {
  width: 48px;
  height: 48px;
  line-height: 48px;
  max-width: 192px;
  max-height: 192px;
}
.nkl-skeleton-element .nkl-skeleton-image-svg.nkl-skeleton-image-circle {
  border-radius: 50%;
}
@keyframes nkl-skeleton-loading {
  0% {
    transform: translateX(-37.5%);
  }
  100% {
    transform: translateX(37.5%);
  }
}
.nkl-skeleton-rtl {
  direction: rtl;
}
.nkl-skeleton-rtl .nkl-skeleton-header {
  padding-right: 0;
  padding-left: 16px;
}
.nkl-skeleton-rtl.nkl-skeleton.nkl-skeleton-active .nkl-skeleton-content .nkl-skeleton-title,
.nkl-skeleton-rtl.nkl-skeleton.nkl-skeleton-active .nkl-skeleton-content .nkl-skeleton-paragraph > li {
  animation-name: nkl-skeleton-loading-rtl;
}
.nkl-skeleton-rtl.nkl-skeleton.nkl-skeleton-active .nkl-skeleton-avatar {
  animation-name: nkl-skeleton-loading-rtl;
}
@keyframes nkl-skeleton-loading-rtl {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
